import {BASIC_FIRST_LOAD} from "../../constants/store";

export const firstLoad = (state = true, action) => {
  switch (action.type) {
    case BASIC_FIRST_LOAD:
      return action.payload;
    default:
      return state;
  }
};